import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { POLLING_INTERVAL_MS } from "../../constants/polling-constants";
import { queryKeys } from "../../lib/queryKeys";
import { getQueryList } from "../../services";

export type QueryListParams = {
  status_id?: string;
  topic_id?: string;
  query_type?: string;
  provider_npi?: string;
  mrn_no?: string;
  filter_id?: string;
  start_date?: string;
  end_date?: string;
  limit?: number;
  page?: number;
  search?: string;
};

export const useQueryList = (
  params: QueryListParams,
  options?: { enabled?: boolean; polling?: boolean }
) => {
  const enabled = options?.enabled ?? true;
  const polling = options?.polling ?? false;

  return useQuery({
    queryKey: queryKeys.queryList(params),
    queryFn: () => getQueryList({ params }),
    enabled,
    placeholderData: keepPreviousData,
    refetchInterval: polling ? POLLING_INTERVAL_MS : false,
  });
};
